module.exports = __webpack_public_path__ + "img/footerafbeelding1.f90e92d7.png";